'use client';

import type { PropsWithChildren } from 'react';
import type { ProjectType } from '~/model/ProjectType';
import { createContext, useContext } from 'react';
import { useProjectFollow } from '../../hooks/useProjectFollow';

const ProjectFollowContext = createContext<ReturnType<typeof useProjectFollow> | undefined>(undefined);

export const useProjectFollowContext = () => {
  const context = useContext(ProjectFollowContext);
  if (!context) {
    throw new Error(
      'useProjectFollowContext must be called within ProjectFollowProvider',
    );
  }
  return context;
};

export const ProjectFollowProvider = ({
  children,
  project,
}: PropsWithChildren<{
  project: ProjectType;
}>) => {
  const value = useProjectFollow(project);

  return (
    <ProjectFollowContext.Provider value={value}>
      {children}
    </ProjectFollowContext.Provider>
  );
};
